import breakpoints from "../__utils/breakpoints";
const $ = jQuery.noConflict();

class SliderNav {
    constructor(selector, slider) {
        this.buttons = $(selector);
        this.section = $(selector).closest("section");
        this.slider = this.section.find(slider);
        this.header = $(".main-header");
    }

    goToSlide(e) {
        if (this.slider.hasClass("slick-initialized")) {
            this.slider.slick(
                "slickGoTo",
                $(e.target).attr("data-index"),
                false
            );
            const top = breakpoints.mobileMax.matches
                ? this.section.offset().top
                : this.slider.offset().top;
            $("html, body").animate(
                {
                    scrollTop: top - this.header.outerHeight(),
                },
                400
            );
        }
    }

    init() {
        this.buttons.on("click", (e) => this.goToSlide(e));
    }
}

const ToursHighlightsSliderNav = new SliderNav(
    ".js-tour-highlights-nav",
    ".bth-slider"
);

export { ToursHighlightsSliderNav };
